var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartmentsAlt5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.66089C9.89543 6.66089 9 7.57656 9 8.7061V20.9774C9 21.5422 9.44772 22 10 22H13V18.4209C13 17.009 14.1193 15.8644 15.5 15.8644C16.8807 15.8644 18 17.009 18 18.4209V22H21C21.5523 22 22 21.5422 22 20.9774V8.7061C22 7.57656 21.1046 6.66089 20 6.66089H11ZM13 8.96175H18C18.4142 8.96175 18.75 9.30513 18.75 9.72871C18.75 10.1523 18.4142 10.4957 18 10.4957H13C12.5858 10.4957 12.25 10.1523 12.25 9.72871C12.25 9.30513 12.5858 8.96175 13 8.96175ZM12.25 12.7966C12.25 12.373 12.5858 12.0296 13 12.0296H18C18.4142 12.0296 18.75 12.373 18.75 12.7966C18.75 13.2201 18.4142 13.5635 18 13.5635H13C12.5858 13.5635 12.25 13.2201 12.25 12.7966Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64888 4.36689C2.25857 4.51657 2 4.89812 2 5.32439V19.9548C2 21.0843 2.89543 22 4 22H7.70802C7.57422 21.6868 7.5 21.341 7.5 20.9774V8.70614C7.5 7.08479 8.55426 5.71524 10 5.27524V3.02353C10 2.30954 9.30263 1.81534 8.64888 2.06604L2.64888 4.36689Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentsAlt5);
export default __webpack_public_path__ + "static/media/apartments-alt-5.c24d518466862f76c3f8b46d960ca713.svg";
export { ForwardRef as ReactComponent };